import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Il_Primo_tower.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Il Primo Tower</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>One of the tallest and most prestigious residential towers in Downtown Dubai, offering ultra-luxury sky apartments within
                walking distance of the Burj Khalifa and Dubai Mall. Il Primo sets a benchmark for premium vertical residential living in the
                world's most iconic urban address.</p>
              <p>MAIN CONTRACTOR : Al Shafar</p>
              <p>MEP CONTRACTOR : -</p>
              <p>GEMCO SCOPE OF WORKS : CHW and electrical works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>


  )
}

export default Project_one